import { render, staticRenderFns } from "./AddPreviewModal.vue?vue&type=template&id=1995f2dc&scoped=true&"
import script from "./AddPreviewModal.vue?vue&type=script&lang=js&"
export * from "./AddPreviewModal.vue?vue&type=script&lang=js&"
import style0 from "./AddPreviewModal.vue?vue&type=style&index=0&id=1995f2dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1995f2dc",
  null
  
)

export default component.exports